import { FileBrowserItem } from './FileBrowser';

const TYPES = {
  FOLDER: 'folder',
  PROJECT: 'project',
};

export const isDir = (summary: FileBrowserItem) => summary.type === TYPES.FOLDER;
